import { getFilteredOffers, getOfferById, getOffersAll, getOffersSummary } from '../api/OffersApi';
import useBaseQuery from '../hooks/useBaseQuery';
import {
  IBaseQueryOptions,
  IOfferFilteringOptions,
  IOffers,
  IOffer,
  IOffersItem,
  AdminFilters,
} from '../types';
import IQueryKeys from '../types/IQueryKeys';

function mapOffer(offer: IOffersItem): IOffersItem {
  if (offer.lead.industry === '1' && !offer.equipmentFee) {
    return {
      ...offer,
      equipmentFeeText: 'Varies per terminal',
    };
  }

  return offer;
}

export const useOffersAllQuery = (
  params: IOfferFilteringOptions,
  options?: IBaseQueryOptions<IOffers>,
) => {
  return useBaseQuery([IQueryKeys.offersAllKey, params], () => getOffersAll(params), {
    ...options,
    select: (res) => {
      return {
        ...res,
        data: {
          ...res.data,
          items: res.data.items.map(mapOffer),
        },
      };
    },
  });
};

export const useOfferByIdQuery = (id: number, options?: IBaseQueryOptions<IOffer>) => {
  return useBaseQuery([IQueryKeys.offersByIdKey, id], () => getOfferById(id), {
    ...options,
    select: (res) => ({ ...res, data: mapOffer(res.data) }),
  });
};

export const useFilteredOffersQuery = (filters: AdminFilters) => {
  return useBaseQuery(
    [IQueryKeys.filteredOffersKey, filters],
    () => getFilteredOffers(filters),
    {},
  );
};

export const useOffersSummaryQuery = (enabled: boolean, refetchInterval: number = 10000) => {
  return useBaseQuery([IQueryKeys.offersSummaryKey], () => getOffersSummary(), {
    enabled,
    refetchInterval,
  });
};
